export default "__VITE_ASSET__DV0pR$mL__"